import state from './module-invoice-checking-update-state';
import mutations from './module-invoice-checking-update-mutations';
import actions from './module-invoice-checking-update-actions';
import getters from './module-invoice-checking-update-getters';

/**
 * store of invoice checking update
 */
export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
